import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaInstagram, FaTiktok, FaPaperPlane, FaMapMarkerAlt } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; 
import Layout from "./shop/layout/index";

const ContactUsComponent = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simuler l'envoi
    setTimeout(() => {
      setIsSubmitting(false);
      alert("Message envoyé avec succès !");
      setFormData({ name: '', email: '', message: '' });
    }, 1500);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const contactMethods = [
    {
      icon: FaWhatsapp,
      title: "WhatsApp",
      value: "+221 77 733 61 09",
      link: "https://wa.me/221777336109",
      color: "bg-green-500",
      bgColor: "bg-green-50",
      hoverColor: "hover:bg-green-100"
    },
    {
      icon: FaPhoneAlt,
      title: "Téléphone",
      value: "+221 77 733 61 09",
      link: "tel:+221777336109",
      color: "bg-blue-600",
      bgColor: "bg-blue-50",
      hoverColor: "hover:bg-blue-100"
    },
    {
      icon: FaEnvelope,
      title: "Email",
      value: "diamadiaw08@gmail.com",
      link: "mailto:diamadiaw08@gmail.com",
      color: "bg-orange-500",
      bgColor: "bg-orange-50",
      hoverColor: "hover:bg-orange-100"
    }
  ];

  const socialMedia = [
    {
      icon: FaXTwitter,
      name: "Twitter",
      handle: "@Jamaaal_d",
      link: "https://twitter.com/Jamaaal_d",
      color: "bg-black",
      bgColor: "bg-gray-50"
    },
    {
      icon: FaInstagram,
      name: "Instagram",
      handle: "@Diamaa_d",
      link: "https://instagram.com/Diamaa_d",
      color: "bg-pink-500",
      bgColor: "bg-pink-50"
    },
    {
      icon: FaTiktok,
      name: "TikTok",
      handle: "@Jamaaal_d",
      link: "https://tiktok.com/@Jamaaal_d",
      color: "bg-gray-800",
      bgColor: "bg-gray-50"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      {/* Header avec animation */}
      <div className="max-w-7xl mx-auto text-center mb-12 animate-fade-in">
        <div className="inline-block mb-4 animate-bounce-slow">
          <div className="w-20 h-20 mx-auto bg-blue-600 rounded-full flex items-center justify-center shadow-2xl">
            <FaEnvelope className="text-white text-3xl" />
          </div>
        </div>
        <h1 className="text-5xl md:text-6xl font-bold text-blue-800 mb-4 animate-slide-up">
          Contactez-Nous
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto animate-slide-up-delay">
          Nous sommes là pour vous aider. Envoyez-nous un message et nous vous répondrons dans les plus brefs délais.
        </p>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Formulaire de contact modernisé */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 transform transition-all duration-500 hover:scale-[1.02] hover:shadow-3xl animate-slide-left">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
                <FaPaperPlane className="text-white text-xl" />
              </div>
              <h2 className="text-3xl font-bold text-gray-800">Envoyez un message</h2>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="relative group">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Votre nom"
                  required
                  className="w-full px-6 py-4 rounded-xl border-2 border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none transition-all duration-300 bg-gray-50 focus:bg-white text-gray-800 placeholder-gray-400"
                />
              </div>

              <div className="relative group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Votre email"
                  required
                  className="w-full px-6 py-4 rounded-xl border-2 border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none transition-all duration-300 bg-gray-50 focus:bg-white text-gray-800 placeholder-gray-400"
                />
              </div>

              <div className="relative group">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Votre message..."
                  rows="6"
                  required
                  className="w-full px-6 py-4 rounded-xl border-2 border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none transition-all duration-300 resize-none bg-gray-50 focus:bg-white text-gray-800 placeholder-gray-400"
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full py-4 rounded-xl font-bold text-lg text-white shadow-xl transform transition-all duration-300 ${
                  isSubmitting 
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-blue-600 hover:bg-blue-700 hover:scale-[1.02] hover:shadow-2xl active:scale-95'
                }`}
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Envoi en cours...
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-2">
                    Envoyer le message
                    <FaPaperPlane className="transform transition-transform group-hover:translate-x-1" />
                  </span>
                )}
              </button>
            </form>
          </div>

          {/* Méthodes de contact */}
          <div className="space-y-6 animate-slide-right">
            <div className="bg-white rounded-3xl shadow-2xl p-8 transform transition-all duration-500 hover:scale-[1.02] hover:shadow-3xl">
              <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
                  <FaPhoneAlt className="text-white text-xl" />
                </div>
                Nos coordonnées
              </h2>

              <div className="space-y-4">
                {contactMethods.map((method, index) => {
                  const Icon = method.icon;
                  return (
                    <a
                      key={index}
                      href={method.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onMouseEnter={() => setHoveredCard(index)}
                      onMouseLeave={() => setHoveredCard(null)}
                      className={`flex items-center gap-4 p-5 rounded-2xl ${method.bgColor} ${method.hoverColor} transition-all duration-300 transform hover:scale-105 hover:shadow-2xl border-2 border-transparent hover:border-gray-200 group cursor-pointer`}
                    >
                      <div className={`w-16 h-16 rounded-2xl ${method.color} flex items-center justify-center shadow-xl transform transition-all duration-300 ${hoveredCard === index ? 'scale-110 rotate-12 shadow-2xl' : ''}`}>
                        <Icon className="text-white text-3xl" />
                      </div>
                      <div className="flex-1">
                        <p className="font-bold text-gray-800 text-base mb-1">{method.title}</p>
                        <p className="text-gray-600 font-medium text-sm">{method.value}</p>
                      </div>
                      <svg className={`w-8 h-8 text-gray-400 transform transition-all duration-300 ${hoveredCard === index ? 'translate-x-2 text-gray-600' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                      </svg>
                    </a>
                  );
                })}
              </div>
            </div>

            {/* Réseaux sociaux */}
            <div className="bg-white rounded-3xl shadow-2xl p-8 transform transition-all duration-500 hover:scale-[1.02] hover:shadow-3xl">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Suivez-nous</h2>
              <div className="grid grid-cols-3 gap-4">
                {socialMedia.map((social, index) => {
                  const Icon = social.icon;
                  return (
                    <a
                      key={index}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${social.bgColor} rounded-2xl p-6 transform transition-all duration-300 hover:scale-110 hover:shadow-2xl hover:-translate-y-3 group cursor-pointer relative overflow-hidden`}
                    >
                      <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                      <div className={`w-16 h-16 mx-auto rounded-2xl ${social.color} flex items-center justify-center mb-3 shadow-2xl transform transition-all duration-300 group-hover:rotate-12 group-hover:scale-110 relative z-10`}>
                        <Icon className="text-white text-3xl drop-shadow-lg" />
                      </div>
                      <p className="text-sm font-bold text-gray-800 text-center mb-1 relative z-10">{social.name}</p>
                      <p className="text-xs text-gray-600 text-center truncate font-medium relative z-10">{social.handle}</p>
                    </a>
                  );
                })}
              </div>
            </div>

            {/* Localisation */}
            <div className="bg-blue-700 rounded-3xl shadow-2xl p-8 text-white transform transition-all duration-500 hover:scale-[1.02] hover:shadow-3xl">
              <div className="flex items-center gap-3 mb-4">
                <FaMapMarkerAlt className="text-3xl" />
                <h3 className="text-2xl font-bold">Notre Localisation</h3>
              </div>
              <p className="text-blue-100 text-lg">
                Dakar, Sénégal
              </p>
              <p className="text-blue-200 mt-2">
                Ouvert du Lundi au Samedi<br />
                9h00 - 22h00
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Styles CSS personnalisés pour les animations */}
      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-left {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slide-right {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }

        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }

        .animate-slide-up-delay {
          animation: slide-up 0.8s ease-out 0.2s both;
        }

        .animate-slide-left {
          animation: slide-left 0.8s ease-out;
        }

        .animate-slide-right {
          animation: slide-right 0.8s ease-out;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }

        .shadow-3xl {
          box-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.3);
        }
      `}</style>
    </div>
  );
};

const contactUs = () => {
  return <Layout children={<ContactUsComponent/>} />;
};

export default contactUs;